"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const check = _ref => {
  let {
      title,
      description
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? "title-check" : '') + (description ? " desc-check" : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-check"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-check"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.952 18.381L2.40945 11.2175L2.32165 11.1336C1.94744 10.8279 1.42018 10.8356 1.06819 11.1455C0.674586 11.4919 0.641524 12.0882 0.994841 12.475L8.27133 20.4396L8.35981 20.5241C8.77358 20.8616 9.36983 20.8112 9.7073 20.4153L23.0265 4.79373L23.0987 4.69641C23.3562 4.28534 23.2721 3.76729 22.9072 3.46751C22.5046 3.13683 21.9066 3.18895 21.5692 3.58469L8.952 18.381Z",
    fill: "inherit"
  }));
};
var _default = exports.default = check;